import request from '@/api/request.js'

// 2026-10-05：客服话术独立接口；沿用已有请求/鉴权封装，不影响旧模块。
export default {
  categories: params => request({ url: '/admin_support_phrase/categories', method: 'GET', params }),
  read: params => request({ url: '/admin_support_phrase/read', method: 'GET', params }),
  save: data => request({ url: '/admin_support_phrase/save', method: 'POST', data }),
  remove: data => request({ url: '/admin_support_phrase/delete', method: 'POST', data }),
  saveCategory: data => request({ url: '/admin_support_phrase/saveCategory', method: 'POST', data }),
  removeCategory: data => request({ url: '/admin_support_phrase/deleteCategory', method: 'POST', data })
}
